module.exports = __webpack_public_path__ + "img/Hawaiian Meal-Maui Chicken.42948055.jpg";